import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/DocumentStatsTypes'

export const fetchComplianceStats = createAction(types.FETCH_COMPLIANCE_STATS)
export const fetchComplianceStatsFailed = createAction(types.FETCH_COMPLIANCE_STATS_FAILED)
export const fetchComplianceStatsSucceeded = createAction(types.FETCH_COMPLIANCE_STATS_SUCCEEDED)
export const fetchDocumentTypeStats = createAction(types.FETCH_DOCUMENT_TYPE_STATS)
export const fetchDocumentTypeStatsFailed = createAction(types.FETCH_DOCUMENT_TYPE_STATS_FAILED)
export const fetchDocumentTypeStatsSucceeded = createAction(
  types.FETCH_DOCUMENT_TYPE_STATS_SUCCEEDED,
)
export const fetchPaymentStats = createAction(types.FETCH_PAYMENT_STATS)
export const fetchPaymentStatsFailed = createAction(types.FETCH_PAYMENT_STATS_FAILED)
export const fetchPaymentStatsSucceeded = createAction(types.FETCH_PAYMENT_STATS_SUCCEEDED)
export const fetchTotalUploadsStats = createAction(types.FETCH_TOTAL_UPLOADS_STATS)
export const fetchTotalUploadsStatsFailed = createAction(types.FETCH_TOTAL_UPLOADS_STATS_FAILED)
export const fetchTotalUploadsStatsSucceeded = createAction(
  types.FETCH_TOTAL_UPLOADS_STATS_SUCCEEDED,
)

//New Invoices
export const fetchNewInvoicesStats = createAction(types.FETCH_INVOICES_STATS)
export const fetchNewInvoicesStatsFailed = createAction(types.FETCH_INVOICES_STATS_FAILED)
export const fetchNewInvoicesStatsSucceeded = createAction(types.FETCH_INVOICES_STATS_SUCCEEDED)

//Pending Invoices
export const fetchPendingInvoicesStats = createAction(types.FETCH_PENDING_INVOICES_STATS)
export const fetchPendingInvoicesStatsFailed = createAction(
  types.FETCH_PENDING_INVOICES_STATS_FAILED,
)
export const fetchPendingInvoicesStatsSucceeded = createAction(
  types.FETCH_PENDING_INVOICES_STATS_SUCCEEDED,
)

//Dicount Invoices
export const fetchDiscountInvoicesStats = createAction(types.FETCH_DISCOUNT_INVOICES_STATS)
export const fetchDiscountInvoicesStatsFailed = createAction(
  types.FETCH_DISCOUNT_INVOICES_STATS_FAILED,
)
export const fetchDiscountInvoicesStatsSucceeded = createAction(
  types.FETCH_DISCOUNT_INVOICES_STATS_SUCCEEDED,
)

//PastDue Invoices
export const fetchPastDueInvoicesStats = createAction(types.FETCH_PAST_DUE_INVOICES_STATS)
export const fetchPastDueInvoicesStatsFailed = createAction(
  types.FETCH_PAST_DUE_INVOICES_STATS_FAILED,
)
export const fetchPastDueInvoicesStatsSucceeded = createAction(
  types.FETCH_PAST_DUE_INVOICES_STATS_SUCCEEDED,
)

//PastDue Invoices
export const fetchExceptionInvoicesStats = createAction(types.FETCH_EXCEPTION_INVOICES_STATS)
export const fetchExceptionInvoicesStatsFailed = createAction(
  types.FETCH_EXCEPTION_INVOICES_STATS_FAILED,
)
export const fetchExceptionInvoicesStatsSucceeded = createAction(
  types.FETCH_EXCEPTION_INVOICES_STATS_SUCCEEDED,
)

//PO Invoices
export const fetchPOInvoicesStats = createAction(types.FETCH_PO_INVOICES_STATS)
export const fetchPOInvoicesStatsFailed = createAction(types.FETCH_PO_INVOICES_STATS_FAILED)
export const fetchPOInvoicesStatsSucceeded = createAction(types.FETCH_PO_INVOICES_STATS_SUCCEEDED)

//Vendors Data
export const fetchVendorsInvoicesStats = createAction(types.FETCH_VENDORS_INVOICES_STATS)
export const fetchVendorsInvoicesStatsFailed = createAction(
  types.FETCH_VENDORS_INVOICES_STATS_FAILED,
)
export const fetchVendorsInvoicesStatsSucceeded = createAction(
  types.FETCH_VENDORS_INVOICES_STATS_SUCCEEDED,
)

//Payments Table Data
export const fetchPaymentInvoicesStats = createAction(types.FETCH_PAYMENTS_INVOICES_STATS)
export const fetchPaymentInvoicesStatsFailed = createAction(
  types.FETCH_PAYMENTS_INVOICES_STATS_FAILED,
)
export const fetchPaymentInvoicesStatsSucceeded = createAction(
  types.FETCH_PAYMENTS_INVOICES_STATS_SUCCEEDED,
)
